import { useDispatch } from 'react-redux'

import { TrackAction } from 'services/TrackAction'
import { openModal } from 'store/actions/modals'
import { getHelpLink, isMobile } from 'services/Utilities'
import { Capacitor } from '@capacitor/core'
import { Intercom } from '@capacitor-community/intercom'
import { Dropdown } from 'ui'
import { t } from 'translations'

const HelpMenu: React.FC = () => {
  const dispatch = useDispatch()

  const openIntercom = async () => {
    const isCapacitor = Capacitor.isNativePlatform()

    if (!isCapacitor) return window.Intercom('showNewMessage')

    Intercom.displayMessenger()
  }

  return (
    <Dropdown>
      <Dropdown.Toggle
        data-cy="help-dropdown"
        size={!isMobile() ? 'small' : undefined}
        outlined
        className="btn-outline-light mr-1"
        style={{ height: isMobile() ? '38px' : '32px' }}
      >
        <i className="fas fa-question mr-2"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu direction="right">
        <Dropdown.Item onClick={openIntercom}>
          <i className="fas fa-messages-question fa-fw mr-2" id="intercom_launcher"></i>
          {t('CONTACT_SUPPORT')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            // Track opening help center in intercom
            TrackAction('OPEN_HELP_CENTER', { to: getHelpLink('helpCenter'), from: 'topbar' })
            window.open(getHelpLink('helpCenter'), '_blank')
          }}
        >
          <i className="fas fa-question-circle fa-fw mr-2"></i>
          {t('HELP_CENTER')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            // Track opening help videos in intercom
            TrackAction('OPEN_HELP_VIDEOS', { to: getHelpLink('helpVideos'), from: 'topbar' })
            window.open(getHelpLink('helpVideos'), '_blank')
          }}
        >
          <i className="fas fa-video-arrow-up-right fa-fw mr-2"></i>
          {t('HELP_VIDEOS')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            // Track opening whats new in intercom
            TrackAction('OPEN_WHATS_NEW', { to: getHelpLink('new'), from: 'topbar' })
            window.open(getHelpLink('new'), '_blank')
          }}
        >
          <i className="fas fa-star-exclamation fa-fw mr-2"></i>
          {t('WHATS_NEW')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            dispatch(openModal('ImportantInformationModal'))
          }}
        >
          <i className="fas fa-info-circle fa-fw mr-2"></i>
          {t('IMPORTANT_INFORMATION')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default HelpMenu
